import { useState, useEffect, useCallback } from 'react';

export const useBusinessData = (fetchFunction, processFunction, id = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [processedData, setProcessedData] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchFunction(id);
      if (response) {
        setData(response);

        if (processFunction) {
          // Only process if we have the right data structure
          const dataToProcess = response.quotes || [];
          const processed = processFunction(dataToProcess);
          setProcessedData(processed);
        }
      }
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, [id, fetchFunction, processFunction]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    processedData,
    loading,
    error,
    refetchData: fetchData,
  };
};
